<ion-card class="lucky-slider ms-2" (click)="showGoldExpandView(); onClick('gold_rings_widget');">
  <ion-icon name="information-circle-outline" (click)="picktings_open()" class="i-info"></ion-icon>
  <div class="second-card">
    <img src="../../../../{{goldRingWidgetDetails?.icon_url}}" alt="Gold ring widget icon" />
  </div>
  <div class="gold-title">
    <h5>{{goldRingWidgetDetails?.title}}</h5>
  </div>
  @if (goldStatus) {
    <ng-lottie
      [options]="goldoptions"
      class="gold-animation"
      (click)="onClick('gold_rings_widget'); showGoldExpandView();"
      (animationCreated)="updateAnimationStatus('gold_rings_widget', goldDuration);"
    ></ng-lottie>
  }
  <div class="gold-subtitle">
    <h6>{{goldRingWidgetDetails?.subtitle}}</h6>
  </div>
</ion-card>
@if (showGoldRingToolTip) {
  <div class="auto-tooltip" (click)="grToolTip()">
    <p>{{goldRingToolTipMsg}}</p>
  </div>
}
